<template>
    <MaltImg
        v-if="typeof props.svgIcon === 'string'"
        :alt="props.svgIcon"
        :src="`/navbar/icons/${props.svgIcon}.svg`"
        :height="svgSize"
        :width="svgSize"
        class="icon-img-wrapper"
    />
    <Component :is="props.svgIcon" v-else v-bind="props" />
</template>

<script setup lang="ts">
    import {MaltImg} from '#components';
    import type {CommonIconProps} from '../icons/common-props';

    interface Props extends CommonIconProps {
        svgIcon?: unknown;
    }

    const props = withDefaults(defineProps<Props>(), {
        svgSize: 18,
        svgColor: 'var(--joy-color-neutral-60)',
    });
</script>
